import { ReactElement } from 'react';
import { useCatalogPaginationFilters, useSearchData } from '@client/catalog/hooks';
import { Pagination } from '@client/common/components/Pagination';

export const CatalogPagination = (): ReactElement => {
  const { data } = useSearchData();
  const { paginationFilters, onPageChange } = useCatalogPaginationFilters();

  return (
    <Pagination
      onPageChange={onPageChange}
      page={parseInt(`${paginationFilters.page}`)}
      total={data.site ? data.site.total : 1}
    />
  );
};
